import React from 'react';
import './announcement.css';

const DEFAULT_SLIDE_EMBED_URL =
  'https://docs.google.com/presentation/d/e/2PACX-1vRKdlFDHsUwXxwmiBrK1We6nPz9EttN7EG86xSNyKMAbseSOgVjeAiqtQ4GXtmWgwIdPKOOynIEBjmV/pubembed?start=false&loop=false&delayms=3000';


function Announcement({ title = 'Sathya Sai Center Milwaukee Announcement', embedUrl = DEFAULT_SLIDE_EMBED_URL }) {
  return (
    <section className="announcement-wrapper">
      <h2>{title}</h2>
      <div className="google-slides-frame-container">
        <iframe
          title="Google Slides Embed"
          src={embedUrl}
          frameBorder="0"
          allowFullScreen
          mozallowfullscreen="true"
          webkitallowfullscreen="true"
          className="google-slides-iframe"
        />
      </div>
    </section>
  );
}

export default Announcement;
